import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function getDeviceId() {
  let id = localStorage.getItem("ss_device_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `d_${Date.now()}_${Math.random()}`;
    localStorage.setItem("ss_device_id", id);
  }
  return id;
}

export const getToken = () => localStorage.getItem("ss_token");
export const setToken = (t) => localStorage.setItem("ss_token", t);
export const clearToken = () => localStorage.removeItem("ss_token");

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const MODE_TINT = {
  CLEAR: "#E8F0EA",
  SETTLE: "#EBF0F5",
  RESTORE: "#F5EDE8",
  PROTECT: "#F0E8ED",
  RECONNECT: "#F7F4E9",
  MOBILIZE: "#F5EBE8",
};

export function fmtTime(s) {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, "0")}`;
}
